var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeaveEventIconinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7499 17.9167C19.243 17.9167 18.8333 18.3274 18.8333 18.8333V22.5001C18.8333 23.0051 18.4225 23.4167 17.9165 23.4167H15.1665V9.66682C15.1665 8.88399 14.6678 8.18458 13.9181 7.92425L13.6467 7.83345H17.9165C18.4225 7.83345 18.8333 8.245 18.8333 8.75022V11.5002C18.8333 12.0061 19.243 12.4168 19.7499 12.4168C20.2567 12.4168 20.6665 12.0061 20.6665 11.5002V8.75022C20.6665 7.23407 19.4326 6.00024 17.9165 6.00024H8.06248C8.02757 6.00024 7.99836 6.01585 7.96446 6.02039C7.92031 6.01669 7.87818 6.00024 7.83337 6.00024C6.82227 6.00024 6 6.82235 6 7.83345V24.3333C6 25.1161 6.49867 25.8155 7.24843 26.0758L12.765 27.9147C12.952 27.9725 13.1379 28 13.3333 28C14.3444 28 15.1665 27.1777 15.1665 26.1666V25.25H17.9165C19.4326 25.25 20.6665 24.0162 20.6665 22.5001V18.8333C20.6665 18.3274 20.2567 17.9167 19.7499 17.9167Z",
    fill: "#F74949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7312 14.5188L24.0645 10.8522C23.8025 10.59 23.4082 10.5111 23.0655 10.6531C22.7236 10.7953 22.4998 11.1298 22.4998 11.5003V14.2502H18.8333C18.3272 14.2502 17.9165 14.6608 17.9165 15.1668C17.9165 15.6729 18.3272 16.0834 18.8333 16.0834H22.4998V18.8334C22.4998 19.2038 22.7236 19.5383 23.0655 19.6805C23.4082 19.8225 23.8025 19.7436 24.0645 19.4816L27.7312 15.8149C28.0896 15.4565 28.0896 14.8771 27.7312 14.5188Z",
    fill: "#F74949"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeaveEventIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leave-event-icon.inline.eb7d525abb8bcaa859c8b98a622b3c97.svg";